export default {
  highlightOffer: {
    id: '',
    title: '',
    description: '',
    displayTitle: '',
    type: null,
    bannerImage: '',
    iconImage: '',
    offersScheduleId: null,
    draft: false,
    initialDate: null,
    finalDate: null,
    tag: {
      active: false,
      image: '',
    },
    products: [],
    productsGroups: [],
    units: [],
  },
  tagType: '',
  status: 'DRAFT',
  isUsingHeaderImage: false,
  offerSchedule: {},
  highlightProducts: null,
  highlightDates: null,
}
